import React from 'react';
import { Box, Chip, Grid } from '@mui/material';
import SearchFilter from './SearchFilter';
import DateRangeFilter from './DateRangeFilters';
import IrbmStatusFilter from './IrbmStatusFilter';
import AdditionalFilters from './AdditionalFilters';

const DocumentListFilters = ({
  filters,
  selectedFilter,
  onFilterChange,
  searchTerm,
  onSearchChange,
  onSearchKeyPress,
  onStatusChange,
  onDateRangeChange,
  includeResubmitted = false,
  onIncludeResubmittedChange,
}) => {
  const searchFilters = filters.filter((filter) => filter.type === 'search');

  return (
    <Grid item xs={12} container justifyContent="space-between" alignItems="center" spacing={1}>
      <Grid container spacing={1}>
        <Grid item>
          <IrbmStatusFilter onChange={onStatusChange} />
        </Grid>
        <Grid>
          <DateRangeFilter onChange={onDateRangeChange} />
        </Grid>
        <Grid>
          <AdditionalFilters
            includeResubmitted={includeResubmitted}
            onIncludeResubmittedChange={onIncludeResubmittedChange}
          />
        </Grid>
      </Grid>
      <Grid item>
        <Box display="flex" gap={1} justifyContent="flex-end">
          {searchFilters.map((filter) => (
            <SearchFilter
              key={filter.type}
              filter={filter}
              selectedFilter={selectedFilter}
              onFilterChange={onFilterChange}
              searchTerm={searchTerm}
              onSearchChange={onSearchChange}
              onSearchKeyPress={onSearchKeyPress}
            />
          ))}
        </Box>
      </Grid>

      {includeResubmitted && (
        <Grid item size={12}>
          <Chip
            label="Include re-submitted documents"
            size="small"
            onDelete={() => onIncludeResubmittedChange(false)}
            sx={{ ml: 1 }}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default DocumentListFilters;
